import React, { useState } from 'react';
import { getCurrentSession } from '../services/auth';

const API_BASE = process.env.REACT_APP_API_BASE || 'https://app.titanelectricreno.com:8080/api';

// Self-service PIN change, usable from the worker dashboard and the admin
// sidebar. Field crew must confirm their current PIN; office/admin roles are
// trusted to reset their own without it (the server enforces the same rule).
export default function ChangePinModal({ onClose }) {
  const session = getCurrentSession();
  const userId = session?.user?.id;
  const role = session?.role;
  const needsCurrent = !['admin', 'ProjectManager', 'Accounting', 'OfficeStaff'].includes(role);

  const [cur, setCur]         = useState('');
  const [next, setNext]       = useState('');
  const [confirm, setConfirm] = useState('');
  const [err, setErr]         = useState('');
  const [saving, setSaving]   = useState(false);
  const [done, setDone]       = useState(false);

  const only4 = v => v.replace(/\D/g, '').slice(0, 4);

  async function submit() {
    setErr('');
    if (next.length !== 4) return setErr('New PIN must be exactly 4 numbers.');
    if (next !== confirm) return setErr('New PIN and confirmation don’t match.');
    if (needsCurrent && cur.length !== 4) return setErr('Enter your current PIN.');
    setSaving(true);
    try {
      const res = await fetch(`${API_BASE}/users/${userId}/pin`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', 'x-worker-token': session?.token },
        body: JSON.stringify({ pin: next, currentPin: cur }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || 'Could not update PIN.');
      setDone(true);
    } catch (e) { setErr(e.message); }
    setSaving(false);
  }

  const boxStyle = { width: '100%', boxSizing: 'border-box', border: '1.5px solid #d1d5db', borderRadius: 8, padding: '10px 12px', fontSize: 18, letterSpacing: 6, textAlign: 'center', fontWeight: 700 };
  const label = { fontSize: 12, fontWeight: 600, color: '#6b7280', marginBottom: 4, display: 'block' };

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)', zIndex: 7000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 14, width: 340, maxWidth: '100%', boxShadow: '0 12px 40px rgba(0,0,0,0.25)', overflow: 'hidden' }}>
        <div style={{ background: '#111827', color: '#fff', padding: '14px 18px', display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 16 }}>🔑</span>
          <span style={{ fontWeight: 800, fontSize: 15, flex: 1 }}>Change PIN</span>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 20, cursor: 'pointer' }}>×</button>
        </div>

        <div style={{ padding: 18 }}>
          {done ? (
            <div style={{ textAlign: 'center', padding: '10px 0' }}>
              <div style={{ fontSize: 34, marginBottom: 6 }}>✅</div>
              <div style={{ fontWeight: 700, fontSize: 15, color: '#111827', marginBottom: 4 }}>PIN updated</div>
              <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 16 }}>Use your new PIN next time you log in.</div>
              <button onClick={onClose} style={{ width: '100%', padding: '11px 0', background: '#16a34a', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 14, cursor: 'pointer' }}>Done</button>
            </div>
          ) : (
            <>
              {needsCurrent && (
                <div style={{ marginBottom: 12 }}>
                  <label style={label}>Current PIN</label>
                  <input type="password" inputMode="numeric" autoComplete="off" value={cur}
                    onChange={e => setCur(only4(e.target.value))} placeholder="••••" style={boxStyle} />
                </div>
              )}
              <div style={{ marginBottom: 12 }}>
                <label style={label}>New PIN (4 numbers)</label>
                <input type="password" inputMode="numeric" autoComplete="off" value={next}
                  onChange={e => setNext(only4(e.target.value))} placeholder="••••" style={boxStyle} />
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={label}>Confirm New PIN</label>
                <input type="password" inputMode="numeric" autoComplete="off" value={confirm}
                  onChange={e => setConfirm(only4(e.target.value))} placeholder="••••" style={boxStyle} />
              </div>
              {err && <div style={{ color: '#dc2626', fontSize: 13, marginBottom: 12, fontWeight: 600 }}>{err}</div>}
              <button onClick={submit} disabled={saving}
                style={{ width: '100%', padding: '12px 0', background: saving ? '#9ca3af' : '#e87722', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 800, fontSize: 15, cursor: saving ? 'default' : 'pointer' }}>
                {saving ? 'Saving…' : 'Save New PIN'}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
